import { render, staticRenderFns } from "./version-setting.vue?vue&type=template&id=562eafab&scoped=true"
import script from "./version-setting.vue?vue&type=script&lang=js"
export * from "./version-setting.vue?vue&type=script&lang=js"
import style0 from "./version-setting.vue?vue&type=style&index=0&id=562eafab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562eafab",
  null
  
)

export default component.exports